'use client';

import React, { type JSX } from 'react';
import clsx from 'clsx';
import { Header } from 'components/header';
import { RootLink } from 'components/link/link';
import { Logo } from 'components/logo';
import { SignInButton } from 'components/sign-in-button';
import { BlurFade, FocusableLink } from 'ui';

export function RootHeader(): JSX.Element {
  return (
    <Header
      logo={
        <BlurFade yOffset={0}>
          <FocusableLink key="logo" href="/" aria-label="Logo">
            <Logo />
          </FocusableLink>
        </BlurFade>
      }
      mobileLogo={
        <FocusableLink key="mobileLogo" href="/" aria-label="Logo">
          <Logo />
        </FocusableLink>
      }
      links={[
        {
          key: 'showcase',
          item: (
            <BlurFade key="showcase" delay={0.35} yOffset={0}>
              <RootLink
                className="inline-block w-full px-4 py-3 text-md font-semibold text-gray-900 sm:px-0 sm:py-0"
                href="/showcase"
              >
                Showcase
              </RootLink>
            </BlurFade>
          ),
        },
        {
          key: 'changelog',
          item: (
            <BlurFade key="changelog" delay={0.4} yOffset={0}>
              <RootLink
                className="inline-block w-full px-4 py-3 text-md font-semibold text-gray-900 sm:px-0 sm:py-0"
                href="/changelog/1"
              >
                <span className="relative">
                  Changelog
                  <span className="absolute -end-1.5 top-0.5 size-1.5 rounded-full bg-brand-600" />
                </span>
              </RootLink>
            </BlurFade>
          ),
        },
        {
          key: 'blog',
          item: (
            <BlurFade key="blog" delay={0.45} yOffset={0}>
              <RootLink
                className="inline-block w-full px-4 py-3 text-md font-semibold text-gray-900 sm:px-0 sm:py-0"
                href="https://quotion.co/blog"
              >
                Blog
              </RootLink>
            </BlurFade>
          ),
        },
        {
          key: 'partner',
          item: (
            <BlurFade key="partner" delay={0.5} yOffset={0}>
              <RootLink
                className={clsx(
                  'inline-block w-full whitespace-nowrap px-4 py-3 text-md font-semibold text-gray-900 sm:px-0 sm:py-0',
                  '[@media(min-width:640px)_and_(max-width:745px)]:hidden',
                )}
                href="/partner"
                key="partner"
              >
                Partner
              </RootLink>
            </BlurFade>
          ),
        },
        {
          key: 'pricing',
          item: (
            <BlurFade key="pricing" delay={0.55} yOffset={0}>
              <RootLink
                className="inline-block w-full px-4 py-3 text-md font-semibold text-gray-900 sm:px-0 sm:py-0"
                href="/#pricing"
                key="pricing"
              >
                Pricing
              </RootLink>
            </BlurFade>
          ),
        },
      ]}
      actions={[
        {
          key: 'signin',
          item: (
            <BlurFade
              key="signin"
              delay={0.6}
              className="px-4 py-3 sm:px-0 sm:py-0"
              yOffset={0}
            >
              <SignInButton />
            </BlurFade>
          ),
        },
      ]}
    />
  );
}
